export default __webpack_public_path__ + "static/media/freshGoods.eef4796b.PNG";